module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    class: _vm.fieldOuterClass,
    style: (_vm.fieldOuterStyle)
  }, [(_vm.field.clickToEdit && !_vm.editing) ? _c('div', {
    class: _vm.fieldClass,
    staticStyle: {
      "display": "flex"
    },
    style: (_vm.fieldStyle)
  }, [_c('div', {
    staticClass: "grey--text text--darken-2",
    attrs: {
      "hide-details": _vm.hideDetails
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlValue)
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "small": "",
      "text": "",
      "icon": "",
      "color": "grey"
    },
    on: {
      "click": _vm.startEditing
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1) : _c('div', {
    class: _vm.fieldClass,
    style: (_vm.fieldStyle),
    on: {
      "click": _vm.fieldClicked
    }
  }, [(_vm.field.type == 'Text') ? [(_vm.field.rows) ? _c('v-textarea', {
    attrs: {
      "rows": _vm.field.rows,
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine,
      "autofocus": _vm.field.focus,
      "clearable": _vm.field.clearable
    },
    on: {
      "change": _vm.changed,
      "blur": _vm.blurred
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }) : _c('v-text-field', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine,
      "autofocus": _vm.field.focus,
      "clearable": _vm.field.clearable
    },
    on: {
      "change": _vm.changed,
      "blur": _vm.blurred
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'List') ? [_c('v-select', {
    attrs: {
      "items": _vm.options,
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "single-line": _vm.singleLine,
      "multiple": _vm.field.multiple,
      "chips": _vm.field.multiple,
      "return-object": _vm.field.returnObject
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Checkbox') ? [_c('v-checkbox', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Date') ? [_c('DateTime', {
    attrs: {
      "date-only": "",
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Options') ? [_c('v-radio-group', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  }, _vm._l((_vm.options), function(item, index) {
    return _c('v-radio', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 1)] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Switch') ? [_c('v-switch', {
    attrs: {
      "label": _vm.field.title,
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "color": "primary"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Html') ? [_c('div', {
    staticClass: "grey--text text--darken-2",
    attrs: {
      "hide-details": _vm.hideDetails
    },
    domProps: {
      "innerHTML": _vm._s(_vm.htmlValue)
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Button') ? [_c('v-btn', {
    staticStyle: {
      "margin-top": "12px",
      "margin-bottom": "0px",
      "width": "100%"
    },
    attrs: {
      "color": _vm.field.color
    },
    on: {
      "click": function($event) {
        return _vm.$emit('button', _vm.field)
      }
    }
  }, [_vm._v(_vm._s(_vm.field.title))])] : _vm._e(), _vm._v(" "), (_vm.field.type == 'File') ? [_c('FileField', {
    attrs: {
      "record": _vm.record,
      "field": _vm.field
    }
  })] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Embed') ? [_c('div', {
    ref: "embedded"
  }), _vm._v(" "), (!_vm.field.disabled) ? _c('div', {
    staticClass: "pt-2"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Link to information"
    },
    model: {
      value: (_vm.record[_vm.field.name]),
      callback: function($$v) {
        _vm.$set(_vm.record, _vm.field.name, $$v)
      },
      expression: "record[field.name]"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.field.type == 'Group' && _vm.isGroupVisible(_vm.field, _vm.record)) ? [_c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v(_vm._s(_vm.field.title))]), _vm._v(" "), (!_vm.record[_vm.field.name] || _vm.record[_vm.field.name].length < 1) ? _c('div', [_vm._v("\n            No records exist. "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createAndPush($event)
      }
    }
  }, [_vm._v("Create")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.record[_vm.field.name]), function(subRecord, subRecordIndex) {
    return _c('div', {
      key: subRecordIndex,
      staticStyle: {
        "border-left": "solid 5px #ddd",
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "flex-wrap": "wrap",
        "width": "100%"
      }
    }, _vm._l((_vm.field.fields), function(subField, index) {
      return _c('InterfaceField', {
        key: index,
        attrs: {
          "field": subField,
          "settings": _vm.settings,
          "record": subRecord
        }
      })
    }), 1), _vm._v(" "), (!_vm.field.disabled) ? _c('div', {
      staticStyle: {
        "float": "right",
        "margin-top": "-33px"
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({}, on), [_vm._v("keyboard_arrow_down")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": _vm.createAndPush
      }
    }, [_c('v-list-item-title', [_vm._v("Add Another")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          _vm.record[_vm.field.name].splice(subRecordIndex, 1)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Item")])], 1)], 1)], 1)], 1) : _vm._e()])
  })] : _vm._e(), _vm._v(" "), (!_vm.field || !_vm.field.type) ? [_c('div', [_vm._v("MISSING FIELD DEFINITION")])] : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e15ec35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/builder/InterfaceField.vue
// module id = 2594
// module chunks = 1